module.exports = new __parcel__URL__("open-hihat_4.5364cb46.mp3").toString();